const types = {
    // GET ALL TRAINERS
    GET_TRAINERS:"GET_TRAINERS",
    GET_TRAINERS_RESP: "GET_TRAINERS_RESP",
    GET_TRAINERS_CLEAR: "GET_TRAINERS_CLEAR",

    // GET INTERNAL TRAINERS
    GET_INTERNAL_TRAINERS:"GET_INTERNAL_TRAINERS",
    GET_INTERNAL_TRAINERS_RESP: "GET_INTERNAL_TRAINERS_RESP",
    GET_INTERNAL_TRAINERS_CLEAR: "GET_INTERNAL_TRAINERS_CLEAR",

    // GET EXTERNAL TRAINERS
    GET_EXTERNAL_TRAINERS:"GET_EXTERNAL_TRAINERS",
    GET_EXTERNAL_TRAINERS_RESP: "GET_EXTERNAL_TRAINERS_RESP",
    GET_EXTERNAL_TRAINERS_CLEAR: "GET_EXTERNAL_TRAINERS_CLEAR",
 
    // GET ALL MEMBERS
    GET_MEMBERS:"GET_MEMBERS",
    GET_MEMBERS_RESP: "GET_MEMBERS_RESP",
    GET_MEMBERS_CLEAR: "GET_MEMBERS_CLEAR",
   
    //
    POST_WORKSHOP_SUBMIT:"POST_WORKSHOP_SUBMIT",
    POST_WORKSHOP_RESPONSE: "POST_WORKSHOP_RESPONSE",
    POST_WORKSHOP_CLEAR: "POST_WORKSHOP_CLEAR",

    GET_WORKSHOP_DATA:"GET_WORKSHOP_DATA", 
    GET_WORKSHOP_DATA_RESPONSE: "GET_WORKSHOP_DATA_RESPONSE",
    GET_WORKSHOP_DATA_CLEAR: "GET_WORKSHOP_DATA_CLEAR",

    UPDATE_WORKSHOP_DATA:"UPDATE_WORKSHOP_DATA", 
    UPDATE_WORKSHOP_DATA_RESPONSE: "UPDATE_WORKSHOP_DATA_RESPONSE",
    UPDATE_WORKSHOP_DATA_CLEAR: "UPDATE_WORKSHOP_DATA_CLEAR",

    POST_WORKSHOP_TIMEZONE:"POST_WORKSHOP_TIMEZONE",
    POST_WORKSHOP_TIMEZONE_RESPONSE: "POST_WORKSHOP_TIMEZONE_RESPONSE",
    POST_WORKSHOP_TIMEZONE_CLEAR: "POST_WORKSHOP_TIMEZONE_CLEAR",

    UPDATE_WORKSHOP:"UPDATE_WORKSHOP",
    UPDATE_WORKSHOP_RESPONSE:"UPDATE_WORKSHOP_RESPONSE",
    UPDATE_WORKSHOP_RESPONSE_CLEAR: "UPDATE_WORKSHOP_RESPONSE_CLEAR"
}
export default types;